import { Reveal, SectionHeading } from "@/components/Reveal";
import { MANIFESTO } from "@/lib/site";

export default function WhyUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="bg-stone-50 py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <SectionHeading
              overline="Why Choose Us"
              title={
                <>
                  The LooXury <span className="italic bronze-text">standard</span>
                </>
              }
              description="A restroom trailer should never be the compromise of your event. These are the principles every LooXury delivery is built on."
            />
          </div>
        </div>
        <div className="lg:col-span-7">
          <ol className="divide-y divide-stone-200">
            {MANIFESTO.map((item, i) => (
              <Reveal key={item.n} delay={i * 0.06}>
                <li className="group flex gap-8 py-10 lg:gap-14" data-testid={`manifesto-item-${item.n}`}>
                  <span className="font-serif text-5xl font-light italic text-brand-bronze/70 transition-colors duration-500 group-hover:text-brand-bronze lg:text-6xl">
                    {item.n}
                  </span>
                  <div className={i % 2 === 1 ? "lg:pl-10" : ""}>
                    <h3 className="font-serif text-2xl font-normal text-stone-900 sm:text-3xl">{item.title}</h3>
                    <p className="mt-3 max-w-md text-base font-light leading-relaxed text-stone-600">{item.body}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
